import { render, staticRenderFns } from "./OperaContentServeWindow.vue?vue&type=template&id=4ba26e02&scoped=true&"
import script from "./OperaContentServeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaContentServeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaContentServeWindow.vue?vue&type=style&index=0&id=4ba26e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba26e02",
  null
  
)

export default component.exports